const experience = [
  {
    period: 'March 2021 - April 2026 (5Y 2M)',
    company: 'Socket 9 Co., Ltd. (HQ)',
    role: 'Senior Mobile and Web Developer (Front-End) · Remote',
    bullets: [
      'Shipped DLT Taxi Driver and SCB Business Anywhere (React Native) with API and payment integrations',
      'Built ASAPH live streaming marketplace with TypeScript, VideoSDK, and scalable front-end architecture',
      'Currently developing Pikul Wallet e-wallet apps for Asset World Corporation',
      'Working 100% remotely with clear async communication and consistent delivery',
    ],
  },
  {
    period: 'Jan 2019 - Feb 2021 (2Y 2M)',
    company: 'SiamDApp (Thailand) Co.,Ltd.',
    role: 'Web and Mobile Developer (Front-End)',
    bullets: [
      'Released Om Wallet crypto app and Om Merchant POS to production (React Native)',
      'Launched Tokenization Platform and Urban Crowdfunding web apps (React JS)',
      'Built CM-Bus transit and ticket POS systems for Chiang Mai public transport',
    ],
  },
  {
    period: 'Nov 2017 – Dec 2018 (1Y)',
    company: 'School of Public Policy (SPP CMU)',
    role: 'Web-Developer (Front-End)',
    bullets: [
      'Designed and launched the official CMU School of Public Policy website (HTML, CSS, PHP)',
    ],
  },
  {
    period: 'March 2017 – Oct 2017 (8M)',
    company: 'PranWorks Co., Ltd.',
    role: 'Software Engineering (Intern)',
    bullets: [
      'Built front-end web applications with ASP.NET MVC connected to MySQL databases',
    ],
  },
];

export default experience;
